<template>
  <div class="flex flex-col gap-8">

    <div class="vx-row mt-4">
      <OurClients />
    </div>
    
    <div class="vx-row mt-4">
      <MyClients />
    </div>

  </div>
</template>

<script>
import MyClients from '@/components/widgets/MyClients.vue'
import OurClients from '@/components/widgets/OurClients.vue'

export default {
  name: 'dashboard',
  components: {
    MyClients,
    OurClients
  }
}
</script>